export const GENERAL_INFO = 'GENERAL_INFO';
export const AUTO_REPLIES = 'AUTO_REPLIES';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const CUSTOMER_FEEDBACK = 'CUSTOMER_FEEDBACK';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const MESSAGE_TEMPLATES = 'MESSAGE_TEMPLATES';
export const EMAIL_CONFIGURATION = 'EMAIL_CONFIGURATION';
